import React from 'react'
import { useLocation } from 'react-router-dom'
import {
  Breadcrumbs as MuiBreadcrumbs,
  Link,
  Typography,
  Box
} from '@mui/material'
import { NavigateNext as NavigateNextIcon } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'

const Breadcrumbs = () => {
  const location = useLocation()
  const { t } = useTranslation()

  const generateBreadcrumbs = () => {
    const pathnames = location.pathname.split('/').filter((x) => x)
    
    if (pathnames.length === 0) {
      return [{ label: t('navigation.dashboard'), path: '/dashboard' }]
    }

    const breadcrumbs = []
    let currentPath = ''

    pathnames.forEach((name, index) => {
      currentPath += `/${name}`
      
      // Map path to translation key
      let label = name
      if (name === 'dashboard') label = t('navigation.dashboard')
      else if (name === 'users') label = t('navigation.users')
      else if (name === 'reminders') label = t('navigation.reminders')
      else if (name === 'subscriptions') label = t('navigation.subscriptions')
      else if (name === 'configs') label = t('navigation.configs')
      else if (name === 'reports') label = t('navigation.reports')
      else if (name === 'audit-logs') label = t('navigation.auditLogs')
      else if (name === 'settings') label = t('navigation.settings')
      else if (name === 'profile') label = t('navigation.profile')
      
      breadcrumbs.push({
        label,
        path: currentPath,
        isLast: index === pathnames.length - 1
      })
    })

    return breadcrumbs
  }

  const breadcrumbs = generateBreadcrumbs()

  if (breadcrumbs.length <= 1) {
    return null
  }

  return (
    <Box sx={{ p: 2, pb: 1 }}>
      <MuiBreadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
      >
        {breadcrumbs.map((breadcrumb, index) => {
          if (breadcrumb.isLast) {
            return (
              <Typography
                key={breadcrumb.path}
                color="text.primary"
                variant="body2"
                sx={{ fontWeight: 500 }}
              >
                {breadcrumb.label}
              </Typography>
            )
          }

          return (
            <Link
              key={breadcrumb.path}
              color="inherit"
              href={breadcrumb.path}
              variant="body2"
              sx={{
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'underline',
                },
              }}
            >
              {breadcrumb.label}
            </Link>
          )
        })}
      </MuiBreadcrumbs>
    </Box>
  )
}

export default Breadcrumbs
